import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { getData, sendData, updateData } from '../fetchers';

export const useReserveSlotMutation = () => {
  const queryClient = useQueryClient();
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('reservations/:courtId', data, params, queryParams),
    onSuccess: (data) => {
      notify.success(tr(data?.translationKey) || data?.message);

      queryClient.invalidateQueries({
        queryKey: ['available-slots'],
      });

      queryClient.invalidateQueries({
        queryKey: ['unavailable-days'],
      });
    },
  });
};

export const useGetUserReservationsQuery = (params) =>
  useQuery({
    queryKey: ['user-reservations', params?.params],
    queryFn: () => getData('reservations/user', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useCancelReservationMutation = () => {
  const queryClient = useQueryClient();
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData('reservations/cancel/:reservationId', data, params, queryParams),
    onSuccess: (data) => {
      notify.success(tr(data?.translationKey) || data?.message);
      queryClient.invalidateQueries({ queryKey: ['user-reservations'] });
    },
  });
};

export const useGetOrganizerReservationsQuery = (params) =>
  useQuery({
    queryKey: ['organizer-reservations', params?.params],
    queryFn: () => getData('reservations/organizer/:courtId', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useGetCourtReservationsHistoryQuery = (params) =>
  useQuery({
    queryKey: ['court-reservations-history', params?.params],
    queryFn: () => getData('reservations/history/:courtId', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useAllowReschedulingMutation = () => {
  const queryClient = useQueryClient();
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData(
        'reservations/allow-rescheduling/:reservationId',
        data,
        params,
        queryParams
      ),

    onSuccess: (data) => {
      notify.success(tr(data?.translationKey) || data?.message);
      queryClient.invalidateQueries({ queryKey: ['organizer-reservations'] });
    },
  });
};

export const useRescheduleMutation = () => {
  const queryClient = useQueryClient();
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData('reservations/reschedule/:reservationId', data, params, queryParams),

    onSuccess: (data) => {
      notify.success(tr(data?.translationKey) || data?.message);
      queryClient.invalidateQueries({ queryKey: ['user-reservations'] });
    },
  });
};
